/* Splendella (Sensa) — comportements de la page clonée, sans aucun script du concurrent */
(function () {
  var C = window.SPL_CFG || {};
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  document.body.classList.add('spl-dark');

  /* ---------- galerie : défilement + points (mobile), flèches + vignettes (bureau) ---------- */
  function initGallery() {
    var track = document.getElementById('splGalTrack'); if (!track) return;
    var slides = $$('.spl-gal__slide', track), dots = $$('.spl-gal__dots li'), th = $$('.spl-gal__thumb'), cur = 0;
    function mark(i) {
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      th.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
    }
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); mark(i); }
    track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== cur) mark(i); }, { passive: true });
    dots.forEach(function (d, k) { d.querySelector('button').addEventListener('click', function () { go(k); }); });
    th.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = document.querySelector('.spl-gal__arrow--prev'), n = document.querySelector('.spl-gal__arrow--next');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (n) n.addEventListener('click', function () { go(cur + 1); });
    mark(0);
  }

  /* ---------- paliers ---------- */
  var tier = 2;
  function initOffer() {
    var bars = $$('[data-spl-tier]');
    bars.forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        e.preventDefault();
        tier = parseInt(bar.getAttribute('data-spl-tier'), 10) || 1;
        bars.forEach(function (b) { b.classList.toggle('kaching-bundles__bar--selected', b === bar); });
      });
    });
    var m = /[?&]pack=(\d)/.exec(location.search);
    if (m) { var b = document.querySelector('[data-spl-tier="' + m[1] + '"]'); if (b) b.click(); }
  }

  /* ---------- ajout au panier rapide : un seul /cart/add.js (produit + cadeau), code du palier, tiroir ouvert ---------- */
  var cartCache = null;
  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; }).catch(function () { return null; });
  }
  function addToCart(btn) {
    var qty = tier === 3 ? 4 : tier === 2 ? 2 : 1;
    var code = tier === 3 ? C.code4 : tier === 2 ? C.code2 : undefined;
    var gifts = tier === 2 ? [C.gift] : [];
    var items = [{ id: C.variant, quantity: qty }];
    btn.setAttribute('aria-busy', 'true');
    refreshCart().then(function (cart) {
      var have = {};
      ((cart && cart.items) || []).forEach(function (i) { have[i.variant_id] = 1; });
      gifts.forEach(function (g) { if (g && !have[g]) items.push({ id: g, quantity: 1 }); });
    }).catch(function () {}).then(function () {
      return window.zosAjoutRapide ? window.zosAjoutRapide(items, code)
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function () { location.href = '/cart'; });
    }).then(function () { btn.removeAttribute('aria-busy'); setTimeout(refreshCart, 400); }, function () { btn.removeAttribute('aria-busy'); location.href = '/cart'; });
  }
  function initAtc() {
    refreshCart();
    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
    setInterval(function () { if (document.querySelector('cart-drawer.active')) refreshCart(); }, 4000);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-spl-atc]');
      if (btn) { e.preventDefault(); e.stopPropagation(); addToCart(btn); return; }
      var a = e.target.closest('a[href="#spl-pi"]');
      if (a) { e.preventDefault(); var t = document.getElementById('spl-pi'); if (t) window.scrollTo({ top: t.getBoundingClientRect().top + scrollY - 80, behavior: 'smooth' }); }
    }, true);
  }

  /* ---------- mur d'avis ---------- */
  var STAR = '<i class="spl-st"></i>', PER = (window.innerWidth < 750 ? 10 : 6);
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function card(r, i) {
    var st = ''; for (var k = 0; k < 5; k++) st += k < r.s ? STAR : '<i class="spl-st off"></i>';
    var t = esc(r.t), long = r.t.length > 300;
    var txt = long ? esc(r.t.slice(0, 300)) + '<span class="spl-rc__dots">...</span><span class="spl-rc__rest" hidden>' + esc(r.t.slice(300)) + '</span><a class="spl-rc__more" role="button">Leggi di più</a>' : t;
    return '<div class="spl-rc"><div class="spl-rc__head"><span class="spl-rc__name">' + esc(r.n) + '</span> <span class="spl-rc__ver">Acquisto verificato <i><svg viewBox="0 0 12 12" width="11" height="11"><path d="m2.6 5.9 2 2 4.5-4.5" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></i></span></div>' +
      '<div class="spl-rc__stars">' + st + '</div><p class="spl-rc__txt">' + txt + '</p>' +
      (r.p ? '<a class="spl-rc__img"' + (r.v ? ' data-spl-video="' + esc(r.v) + '" data-spl-poster="' + esc(r.p) + '" aria-label="Guarda il video"' : ' data-spl-photo="' + esc(r.p) + '"') + '><img src="' + esc(r.p) + '" alt="Foto della recensione" loading="lazy">' + (r.v ? '<span class="pl"><svg viewBox="0 0 24 24" width="14" height="14"><path d="M8 5v14l11-7z" fill="#fff"/></svg></span>' : '') + '</a>' : '') +
      '<div class="spl-rc__foot"><button type="button" class="spl-rc__like" aria-label="Utile"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 10v11H3V10zM7 10l4-8a3 3 0 013 3v4h5.5a2 2 0 012 2.3l-1.4 8A2 2 0 0118.1 21H7"/></svg><span>' + r.l + '</span></button></div></div>';
  }
  function initReviews() {
    var root = document.getElementById('spl-reviews'); if (!root) return;
    var data = []; try { data = JSON.parse(document.getElementById('spl-reviews-data').textContent); } catch (e) { return; }
    var grid = root.querySelector('.spl-rev__grid'), pag = root.querySelector('.spl-rev__pag'), page = 0, pages = Math.ceil(data.length / PER);
    function render() {
      var cols = window.innerWidth >= 750 ? 4 : 1, html = [], h = [];
      for (var c = 0; c < cols; c++) { html.push(''); h.push(0); }
      data.slice(page * PER, page * PER + PER).forEach(function (r, i) {
        var c = 0; for (var k = 1; k < cols; k++) if (h[k] < h[c]) c = k;
        html[c] += card(r, i); h[c] += 120 + r.t.length / 2 + (r.p ? 300 : 0);
      });
      grid.innerHTML = html.map(function (x) { return '<div class="spl-rev__col">' + x + '</div>'; }).join('');
      var p = '<li><button type="button" data-p="prev">«</button></li>';
      for (var i = 0; i < pages; i++) p += '<li><button type="button" data-p="' + i + '"' + (i === page ? ' class="on"' : '') + '>' + (i + 1) + '</button></li>';
      pag.innerHTML = p + '<li><button type="button" data-p="next">»</button></li>';
    }
    pag.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var v = b.getAttribute('data-p');
      page = v === 'prev' ? Math.max(0, page - 1) : v === 'next' ? Math.min(pages - 1, page + 1) : parseInt(v, 10);
      render(); root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    root.addEventListener('click', function (e) {
      var m = e.target.closest('.spl-rc__more');
      if (m) { var p = m.parentNode; p.querySelector('.spl-rc__rest').hidden = false; p.querySelector('.spl-rc__dots').remove(); m.remove(); return; }
      var l = e.target.closest('.spl-rc__like');
      if (l && !l.dataset.done) { var s = l.querySelector('span'); s.textContent = (+s.textContent || 0) + 1; l.dataset.done = 1; return; }
      var ph = e.target.closest('[data-spl-photo]');
      if (ph) { var lb2 = document.querySelector('.spl-lb-img'); if (!lb2) { lb2 = document.createElement('div'); lb2.className = 'spl-lb spl-lb-img'; lb2.innerHTML = '<button type="button" aria-label="Chiudi">×</button><img alt="" style="max-width:92vw;max-height:86vh">'; document.body.appendChild(lb2); lb2.addEventListener('click', function () { lb2.classList.remove('open'); }); } lb2.querySelector('img').src = ph.getAttribute('data-spl-photo'); lb2.classList.add('open'); return; }
      var v = e.target.closest('[data-spl-video]');
      if (v) {
        var lb = document.querySelector('.spl-lb');
        if (!lb) { lb = document.createElement('div'); lb.className = 'spl-lb'; lb.innerHTML = '<button type="button" aria-label="Chiudi">×</button><video controls playsinline></video>'; document.body.appendChild(lb);
          lb.addEventListener('click', function (ev) { if (ev.target === lb || ev.target.tagName === 'BUTTON') { lb.classList.remove('open'); lb.querySelector('video').pause(); } }); }
        var vid = lb.querySelector('video'); vid.style.display = ''; vid.poster = v.getAttribute('data-spl-poster'); vid.src = v.getAttribute('data-spl-video'); lb.classList.add('open'); vid.play().catch(function () {});
      }
    });
    var w = window.innerWidth; window.addEventListener('resize', function () { if ((w >= 750) !== (window.innerWidth >= 750)) { w = window.innerWidth; render(); } });
    render();
  }

  function init() { initGallery(); initOffer(); initAtc(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
